"use client";

import { useActionState } from "react";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { registerAction, type RegisterState } from "./actions";

export default function RegisterForm({ locale }: { locale: string }) {
  const t = useTranslations("Auth");
  const [state, action, isPending] = useActionState<RegisterState, FormData>(
    registerAction,
    {}
  );

  return (
    <form action={action} className="space-y-4">
      <input type="hidden" name="locale" value={locale} />

      {state.error && (
        <div className="rounded-md bg-destructive/10 px-4 py-3 text-sm text-destructive">
          {t(
            state.error as "emailTaken" | "serverError" | "invalidCredentials"
          )}
        </div>
      )}

      <div className="space-y-1.5">
        <Label htmlFor="tenantName">{t("companyName")}</Label>
        <Input
          id="tenantName"
          name="tenantName"
          type="text"
          autoComplete="organization"
          required
          placeholder="Meine Agentur GmbH"
        />
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="email">{t("email")}</Label>
        <Input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          placeholder="name@firma.de"
        />
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="password">{t("password")}</Label>
        <Input
          id="password"
          name="password"
          type="password"
          autoComplete="new-password"
          required
          minLength={6}
        />
      </div>

      <Button type="submit" className="w-full" disabled={isPending}>
        {isPending ? t("registering") : t("registerButton")}
      </Button>
    </form>
  );
}
